import { __values } from "tslib";
import { Menu, MenuItem, MenuList, MenuPopover, } from '@fluentui/react-components';
import { Delete20Regular, Info20Regular, Open20Regular, Pin20Regular, PinOff20Regular, } from '@fluentui/react-icons';
import { useFragment } from '@nova/react';
import AppBarIcons from '@office-start/appbar-icons';
import React from 'react';
import { useTileMenuStyles } from './TileContextMenu.styles';
import { modelFragment as TileContextMenu_tileContextMenu, } from './TileContextMenu.types';
/**
 * Context menu for launch tiles to support pinning and other commands
 * @param onPinStateChange Event fired when pin state for a tile changes
 * @param isPinned True if the connected tile is pinned. False otherwise.
 * @returns JSX.Element
 */
export var TileContextMenu = function (_a) {
    var tileContextMenuRef = _a.tileContextMenu, style = _a.style, menuTarget = _a.menuTarget, menuItemCallbacks = _a.menuItemCallbacks, contextMenuOpen = _a.contextMenuOpen, setContextMenuOpen = _a.setContextMenuOpen;
    var _b = useFragment(TileContextMenu_tileContextMenu, tileContextMenuRef), openInNewTabItemLabel = _b.openInNewTabItemLabel, aboutAppItemLabel = _b.aboutAppItemLabel, pinAppItemLabel = _b.pinAppItemLabel, unpinAppItemLabel = _b.unpinAppItemLabel, uninstallAppItemLabel = _b.uninstallAppItemLabel;
    var styles = useTileMenuStyles();
    var tileMenuItems = React.useMemo(function () {
        var e_1, _a;
        var _b;
        var data = [];
        if (menuItemCallbacks.onLaunchOut) {
            data.push({
                id: 'launchOut',
                text: openInNewTabItemLabel,
                icon: React.createElement(Open20Regular, null),
                onMenuItemClick: menuItemCallbacks.onLaunchOut,
            });
        }
        if (menuItemCallbacks.onGetMoreInfo) {
            data.push({
                id: 'aboutApp',
                text: aboutAppItemLabel,
                icon: React.createElement(Info20Regular, null),
                onMenuItemClick: menuItemCallbacks.onGetMoreInfo,
            });
        }
        if (menuItemCallbacks.customActions &&
            menuItemCallbacks.onCustomAction) {
            var _loop_1 = function (customAction) {
                var IconComponent = undefined;
                if (((_b = customAction.icon) === null || _b === void 0 ? void 0 : _b.name) != null) {
                    IconComponent = AppBarIcons[customAction.icon.name];
                }
                data.push({
                    id: customAction.id,
                    text: customAction.text,
                    icon: IconComponent && React.createElement(IconComponent, null),
                    onMenuItemClick: function (ev) {
                        menuItemCallbacks.onCustomAction &&
                            menuItemCallbacks.onCustomAction(ev, customAction.eventType, customAction.eventData);
                    },
                });
            };
            try {
                for (var _c = __values(menuItemCallbacks.customActions), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var customAction = _d.value;
                    _loop_1(customAction);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        if (menuItemCallbacks.onPinStateChange) {
            var isPinned_1 = menuItemCallbacks.pinnedIndex != null &&
                menuItemCallbacks.pinnedIndex >= 0;
            var command_1 = menuItemCallbacks.onPinStateChange;
            data.push({
                id: isPinned_1 ? 'unpin' : 'pin',
                text: isPinned_1 ? unpinAppItemLabel : pinAppItemLabel,
                icon: isPinned_1 ? React.createElement(PinOff20Regular, null) : React.createElement(Pin20Regular, null),
                onMenuItemClick: function () {
                    command_1(!isPinned_1);
                },
            });
        }
        if (menuItemCallbacks.onUninstall) {
            data.push({
                id: 'uninstallApp',
                text: uninstallAppItemLabel,
                icon: React.createElement(Delete20Regular, null),
                onMenuItemClick: menuItemCallbacks.onUninstall,
            });
        }
        return data === null || data === void 0 ? void 0 : data.map(function (item) {
            return (React.createElement(MenuItem, { key: item.id, icon: item.icon, onClick: function (ev) {
                    item.onMenuItemClick(ev);
                    ev.stopPropagation();
                } }, item.text));
        });
    }, [
        openInNewTabItemLabel,
        aboutAppItemLabel,
        pinAppItemLabel,
        unpinAppItemLabel,
        uninstallAppItemLabel,
        menuItemCallbacks,
    ]);
    var onOpenChange = function (_e, data) {
        setContextMenuOpen(data.open);
    };
    return (React.createElement(Menu, { hasIcons: true, open: contextMenuOpen, onOpenChange: onOpenChange, closeOnScroll: true, positioning: {
            align: 'center',
            position: 'after',
            target: menuTarget,
        } },
        React.createElement(MenuPopover, { className: styles.tileMenuPopover, style: style },
            React.createElement(MenuList, null, tileMenuItems))));
};
export default TileContextMenu;
//# sourceMappingURL=TileContextMenu.js.map